import { render, staticRenderFns } from "./Successful Registration.vue?vue&type=template&id=3520961a&"
import script from "./Successful Registration.vue?vue&type=script&lang=js&"
export * from "./Successful Registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports